var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { IconLeft, IconRight } from '@arco-design/iconbox-react-m4b-next';
import { useConfigContext } from '@m4b-design/config-provider';
import { ArcoIconWrapper } from '@m4b-design/utils';
import cx from 'classnames';
import ArcoCarousel from './core/Carousel';
import './style/carousel.less';
var CarouselRender = function (props, ref) {
    var _a;
    var className = props.className, _b = props.arrowSize, arrowSize = _b === void 0 ? 'large' : _b, _c = props.indicatorType, indicatorType = _c === void 0 ? 'line' : _c, _d = props.indicatorColor, indicatorColor = _d === void 0 ? 'white' : _d, _icons = props.icons, hideIndicatorWrapper = props.hideIndicatorWrapper, restProps = __rest(props, ["className", "arrowSize", "indicatorType", "indicatorColor", "icons", "hideIndicatorWrapper"]);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-carousel");
    var icons = __assign({ prev: React.createElement(ArcoIconWrapper, { Icon: IconLeft }), next: React.createElement(ArcoIconWrapper, { Icon: IconRight }) }, (_icons !== null && _icons !== void 0 ? _icons : {}));
    return (React.createElement(ArcoCarousel, __assign({ indicatorType: indicatorType, className: cx(prefixCls, "".concat(prefixCls, "-arrow-").concat(arrowSize), "".concat(prefixCls, "-indicator-").concat(indicatorColor), (_a = {}, _a["".concat(prefixCls, "-indicator-hide-wrapper")] = hideIndicatorWrapper, _a), className), ref: ref, icons: icons }, restProps, { "data-tid": "m4b_carousel" })));
};
var Carousel = forwardRef(CarouselRender);
Carousel.displayName = 'Carousel';
export default Carousel;
